import api from './api';
import type { DashboardResponse } from '@/types/dashboard';

export const dashboardApi = {
    async getDashboard(): Promise<DashboardResponse> {
        try {
            const response = await api.get('/admin/dashboard');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching dashboard data:', error);
            throw new Error(error.response?.data?.error || 'Dashboard verileri yüklenemedi');
        }
    },
};